/** Compras do quadro cujas notas de entrada vinculadas (vínculo ativo) devem ser devolvidas. */
export class NotaFiscalEntradaNotasPorComprasRequest {
  idsCompra: number[] = [];
}
